import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { login } from 'store/user';
import { report, setReportUser } from 'store/report';
import { useAppDispatch } from 'store/index';

export default (ignoreAppReq = false) => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [pending, setPending] = useState<boolean>(true);

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    if (query.get('sso_ticket')) {
      const ticket = query.get('sso_ticket');

      query.delete('sso_ticket');
      history.replace(`${location.pathname}?${query.toString()}`);

      dispatch(login({ ticket, ignoreAppReq })).then(setReportUser);
      report({ event: 'request-login', payload: ticket });
    } else {
      setPending(false);
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, []);

  return pending;
};
